import { getModules } from '@/stores/config'
import { useSelector } from '@/stores/hooks'
import type { ModuleObject } from '@/util/modules'
import { useLocation } from 'wouter'

export function useModules(): ModuleObject[] {
	return useSelector(getModules)
}
export function useMaybeModule(): ModuleObject | null {
	const modules = useModules()
	const [location] = useLocation()
	for (const module of modules) {
		if (location === module.path || location.startsWith(module.path + '/'))
			return module
	}
	return null
}
export function useModule(): ModuleObject {
	const module = useMaybeModule()
	const [location] = useLocation()
	if (!module) throw new Error(`Not in any module at ${location}`)
	return module
}
